import { useConnect } from '@lore/query-connect';
import { partnerResponses } from '@/pages/dashboard-year/Projects/_projectInvitationDeclineReasons';

import { project_networkId } from '@/utils/query-helpers';

export default function useProjectInvitationsResponded(network, timestamp) {
  return useConnect('question.find', {
    where: {
      eager: {
        $where: {
          ...project_networkId(network),
          createdAt: {
            $gte: timestamp.start,
            $lte: timestamp.end
          },
          $or: [{
            response: 'Connect'
          }].concat(partnerResponses.map(function(response) {
            return {
              response: 'Decline',
              responseMessage: {
                $ilike: `%${response}%`
              }
            }
          }))
        }
      },
    },
    pagination: {
      pageSize: 1
    }
  });
}
